/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { SetClearanceCaseManagerResponseJson } from './set-clearance-case-manager-response-json';
import { SetClearanceCaseManagerResult } from '../results/set-clearance-case-manager-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { ClearanceCaseDto } from '../models/clearance-case-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class SetClearanceCaseManagerResponse extends ResponseWithErrorGeneric<SetClearanceCaseManagerResponseJson, SetClearanceCaseManagerResult> implements IResponseWithErrorGeneric<SetClearanceCaseManagerResult> {
  public clearanceCaseId: string = undefined;
  public clearanceCase: ClearanceCaseDto;
  public caseManagerId: string = undefined;
  public caseManager: string = undefined;

  //<custom-body>
  constructor(response: HttpResponse<SetClearanceCaseManagerResponse>) {
    super(response, SetClearanceCaseManagerResult.Error);
    if (this.result !== SetClearanceCaseManagerResult.Success) {
      return;
    }

    this.clearanceCase = this.body.clearanceCase ? new ClearanceCaseDto(this.body.clearanceCase, null) : null;
    this.clearanceCaseId = this.body.clearanceCaseId;
    this.caseManagerId = this.body.caseManagerId;
    this.caseManager = this.body.caseManager;
  }
  //</custom-body>
}
